import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { CmUsersListComponent } from './cm-users-list/cm-users-list.component';

@Component({
  selector: 'app-cm-users',
  templateUrl: './cm-users.component.html',
  styleUrls: ['./cm-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmUsersComponent {

  @ViewChild(CmUsersListComponent) usersListComponent!: CmUsersListComponent;

  ngAfterViewInit(): void {
  }

  // Handle user added event
  onUserAdded(): void {
    console.log('User added successfully! Refreshing users list...');
    this.usersListComponent?.onUserAdded();
  }

  // Handle user updated event
  onUserUpdated(): void {
    console.log('User updated successfully! Refreshing users list...');
    this.usersListComponent?.onUserUpdated();
  }
}
